// cardSettingsStore — per-card tone / length / nudge selections
// persisted to localStorage so they survive refresh. Randy's ask
// (Feb 27 2026 pt-ytre-card-settings-persist):
//   "The settings chosen when creating a re-draft ... would like
//    those to be remembered for the specific card. That way they
//    don't have to re-select them if they want to do a re-draft.
//    They're already set and remembered for that card."
//
// Scoping: KEYED BY entry.id — persists ONLY for that specific card.
// Not shared across siblings, not persisted to backend.

const KEY = (entryId) => `mysilo:card:${entryId}:settings`;

export function readCardSettings(entryId) {
  if (!entryId || typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(KEY(entryId));
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

export function writeCardSettings(entryId, patch) {
  if (!entryId || typeof window === "undefined") return;
  try {
    const cur = readCardSettings(entryId) || {};
    const next = { ...cur, ...patch };
    // Drop null/undefined so the object doesn't grow indefinitely.
    Object.keys(next).forEach((k) => { if (next[k] == null) delete next[k]; });
    if (Object.keys(next).length === 0) {
      window.localStorage.removeItem(KEY(entryId));
    } else {
      window.localStorage.setItem(KEY(entryId), JSON.stringify(next));
    }
  } catch { /* quota exceeded or private mode — silent */ }
}
